/* eslint-disable */
import { produce } from "immer";
import {
  HELP_GUIDES_FETCH_FAILURE,
  HELP_GUIDES_FETCH_SUCCESS,
  HELP_GUIDES_FETCH_START,
} from "../actions/types";

const helpGuidesIllustrations = (
  state = {
    helpGuidesIllustrationsFetching: false,
    helpGuidesIllustrationsData: [],
    helpGuidesIllustrationsError: null,
  },
  action,
) => {
  switch (action.type) {
    case HELP_GUIDES_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case HELP_GUIDES_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case HELP_GUIDES_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default helpGuidesIllustrations;
